import { useOffline } from '../../hooks/useOffline';
import { Wifi, WifiOff, RefreshCw, CloudOff, Cloud } from 'lucide-react';
// DISABLED: framer-motion causes React 19 crash loop (NotFoundError: insertBefore/removeChild)

export function PWAStatus() {
  const { isOnline, isSyncing, pendingCount } = useOffline();

  if (isOnline && pendingCount === 0) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] px-4 pt-2">
      <div className="mx-auto max-w-md">
        {!isOnline ? (
          <div className="bg-amber-500 text-white px-4 py-3 rounded-xl shadow-lg flex items-center gap-3">
            <CloudOff className="w-5 h-5 flex-shrink-0" />
            <span className="text-sm font-medium">Sei offline - dati salvati locally</span>
          </div>
        ) : pendingCount > 0 && (
          <div className="bg-blue-500 text-white px-4 py-3 rounded-xl shadow-lg flex items-center gap-3">
            {isSyncing ? (
              <>
                <RefreshCw className="w-5 h-5 flex-shrink-0 animate-spin" />
                <span className="text-sm font-medium">Sincronizzazione in corso...</span>
              </>
            ) : (
              <>
                <Cloud className="w-5 h-5 flex-shrink-0" />
                <span className="text-sm font-medium">{pendingCount} modifiche in attesa</span>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export function NetworkIndicator() {
  const { isOnline, isSyncing, pendingCount } = useOffline();

  return (
    <div className={`flex items-center gap-1.5 text-xs ${isOnline ? 'text-green-600' : 'text-amber-600'}`}>
      {isOnline ? (
        <>
          <Wifi className="w-3.5 h-3.5" />
          {pendingCount > 0 && <span className="ml-1">({pendingCount})</span>}
        </>
      ) : (
        <>
          <WifiOff className="w-3.5 h-3.5" />
          <span>Offline</span>
        </>
      )}
      {isSyncing && <RefreshCw className="w-3 h-3 animate-spin ml-1" />}
    </div>
  );
}

export default PWAStatus;